import React from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Cross1Icon } from '@radix-ui/react-icons';

import { Tab } from '../../features/tabs/models/tab';
import { api } from '../../api';

import styles from './tab-item.module.scss';
type TabProps = {
  tab: Tab;
  active?: boolean;
  id?: string;
  onClose: (key: string) => void;
};

export const TabItem: React.FC<TabProps> = observer(({ tab, active, id, onClose }) => {
  const navigate = useNavigate();

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    tab.close();
    onClose(tab.key);
  };

  const handleOpenTab = () => {
    api.updateSpaceInHeaders(tab.href.split('/')[2]!);
    navigate(tab.href);
  };

  return (
    <div className={styles['container']} id={id} data-is-active={active} onClick={handleOpenTab}>
      {tab.label ? <span>{tab.label}</span> : <span className={styles['label-placeholder']} />}

      <span onClick={handleClose}>
        <Cross1Icon />
      </span>
    </div>
  );
});
